import { dramas } from '@/mocks/dramas';
import CategoryPage, { type CategoryConfig } from '@/pages/category/components/CategoryPage';

const config: CategoryConfig = {
  slug: 'ethics',
  title: '伦理剧集',
  subtitle: 'Ethics Drama',
  intro:
    '伦理剧集聚焦家庭、情感与人性的多重抉择，把日常关系里最难说出口的部分摊开来讲。这里收录站内全部伦理题材作品资料，可按年份、地区与评分筛选。',
  description:
    '伦理剧的魅力在于它从不提供简单的答案。家庭伦理作品常围绕亲情、赡养与代际误解展开；情感伦理作品则更多关注婚姻中的忠诚、克制与自我成全。本站对每部作品的导演、编剧、主演与剧情梗概做了整理，方便在观看前先了解故事的来龙去脉。筛选与排序基于站内演示数据，评分仅作参考示意。',
  base: dramas,
};

export default function EthicsCategoryPage() {
  return <CategoryPage config={config} />;
}